import { createApp } from 'vue';
import App from './App.vue';
import router from './routers';
import store from './store';
import i18n from './i18n';
import './assets/styles.css';
import api from './services/api';



// Agrega MSAL al prototipo de Vue
const app = createApp(App);

// Usa el router y el store
app.use(store);
app.use(router);

// en main.ts

window.addEventListener('storage', (event) => {
  // Nos interesa si cambia el authToken o el user (que cambia junto al token)
  if (event.key === 'authToken' || event.key === 'user') {
    
    // CASO 1: Se cerró sesión en otra pestaña (el nuevo valor es nulo)
    if (!event.newValue) {
      console.log('Sesión cerrada en otra pestaña, actualizando estado local...');
      // Verificamos si el usuario ya está deslogueado para no hacerlo dos veces
      if (store.state.authenticated) {
        store.dispatch('logOut');
        router.push('/login');
      }
    } 
    // CASO 2: Se refrescó la sesión en otra pestaña (hay un nuevo token)
    else {
      console.log('Token/Usuario actualizado en otra pestaña, sincronizando estado en memoria...');
      
      // 1. Leemos los nuevos datos desde localStorage
      const newAuthToken = localStorage.getItem('authToken');
      const newUserJSON = localStorage.getItem('user');

      if (newAuthToken && newUserJSON) {
        // 2. Actualizamos el store de Vuex llamando a las mutaciones
        store.commit('SET_AUTH', true);
        store.commit('SET_USER', JSON.parse(newUserJSON));
        
        // 3. Actualizamos la cabecera por defecto de Axios para futuras peticiones
        api.defaults.headers.common['Authorization'] = `Bearer ${newAuthToken}`;

        console.log("Sincronización silenciosa completada.");
      }
    }
  }
});

app.use(i18n);

// Monta la aplicación
app.mount('#app');
